import { Component, OnInit, Input, OnDestroy, Inject } from '@angular/core';
import { TrelloCheckItem } from '../../../trello-misc/data/trello-check-item';
import { trackEntityById, API_URL } from 'projects/core/src/public-api';
import { ProjectFile } from '../../data/project/project-file';
import { TrelloService } from '../../../trello-misc/data/trello.service';
import { MatDialog } from '@angular/material/dialog';
import { PdfPreviewDialogComponent } from '../pdf-preview-dialog/pdf-preview-dialog.component';
import { ImageGalleryCarouselComponent } from '../image-gallery-carousel/image-gallery-carousel.component';
import { Gallery } from 'angular-gallery';
import { FileOpenerService } from '../../utils/fileOpener.service';
import { FileService } from 'projects/core/src/lib/misc/data/file/file.service';

@Component({
  selector: 'app-punch-item-files',
  templateUrl: './punch-item-files.component.html',
  styleUrls: ['./punch-item-files.component.scss']
})
export class PunchItemFilesComponent implements OnInit, OnDestroy {

  @Input()
  checkItem: TrelloCheckItem;

  @Input()
  progressBar: number;

  @Input()
  projectId: number;


  trackEntityById = trackEntityById;

  constructor(
    protected fileService: FileService,
    protected fileOpenerService: FileOpenerService,
    @Inject(API_URL) protected apiUrl: string,
    protected trelloService: TrelloService
  ) {
  }

  ngOnInit() {
  }

  deleteFile(file: ProjectFile) {
    if(this.checkItem.id) {
      this.trelloService.deleteFile(file.id, this.checkItem.id).subscribe(deleted => {

        const index = this.checkItem.files.indexOf(file, 0);
        if(index > -1) {
          this.checkItem.files.splice(index, 1);
        }
      })
    } else {
      const index = this.checkItem.files.indexOf(file, 0);
      if(index > -1) {
        this.checkItem.files.splice(index, 1);
      }
    }

  }

  onProgress(event) {
    this.progressBar = event.progress;

    if(this.progressBar === 100) {
    }
  }

  getIcon(ext: string) {
    if(ext === 'jpg' || ext === 'png' || ext === 'gif' || ext === 'webp') {
      return 'photo';
    } else if(ext === 'pdf' || ext === 'doc' || ext === 'docx' || ext === 'txt') {
      return 'insert_drive_file';
    } else if(ext === 'zip' || ext === 'rar') {
      return 'archive';
    } else {
      return 'attach_file';
    }
  }

  updateProgressBar(percent: number) {
    this.progressBar = percent;
  }

  openFile(projectFile: ProjectFile) {
    this.fileOpenerService.openFile(projectFile, this.checkItem.files, true)
  }

  ngOnDestroy() {

  }

}
